import dayjs, { Dayjs } from "dayjs";
import { DataType } from "../constants";

interface Filters {
  process?: string[];
  status?: string;
  dateRange: [Dayjs | null, Dayjs | null];
}

export const filterPlannerData = (data: DataType[], filters: Filters) => {
  return data.filter((item) => {
    if (filters.process?.length && !filters.process.includes(item.processStep))
      return false;
    if (filters.status && item.status !== filters.status) return false;
    if (filters.dateRange[0] && filters.dateRange[1]) {
      const start = dayjs(item.startDate);
      if (
        start.isBefore(filters.dateRange[0], "day") ||
        start.isAfter(filters.dateRange[1], "day")
      )
        return false;
    }
    return true;
  });
};
